var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 244.84 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea989d;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22{stroke-width:0px;}.cls-2{fill:#f79add;}.cls-3{fill:#d7baf4;}.cls-4{fill:#bfdcfe;}.cls-5{fill:none;}.cls-6{fill:#b2edd8;}.cls-7{fill:#c7e288;}.cls-8{fill:#efdf6a;}.cls-9{fill:#ffdbab;}.cls-10{fill:url(#New_Pattern);}.cls-11{fill:#fdbbbc;}.cls-12{fill:#d9efa3;}.cls-13{fill:#98c7ed;}.cls-14{fill:#8fd8be;}.cls-15{fill:#ede9d9;}.cls-16{fill:#f2ede7;}.cls-17{fill:#f2b770;}.cls-18{fill:#fff;}.cls-19{fill:#ba92e8;}.cls-20{fill:#f6bae6;}.cls-21{fill:#ddd9c7;}.cls-22{fill:#fef493;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "New_Pattern",
    x: 0,
    y: 0,
    width: 486.02,
    height: 315.92,
    patternTransform: "translate(85.71 -110)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 486.02 315.92"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 0,
    width: 486.02,
    height: 315.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "440.35 335.81 465.85 390.66 516.68 367.03 491.18 312.18 440.35 335.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M459.67,327.1l-2.29.47.05-2.34c.02-.73.47-18.04,10.7-22.79,1.25-.58,2.61-.95,4.04-1.1,4.55-.47,7.84,1.36,8.82,4.89,1.45,5.27-3.05,13.52-13.11,18.19h0c-2.51,1.17-5.27,2.07-8.2,2.68ZM461.34,322.86c1.75-.49,3.41-1.09,4.96-1.81h0c8.61-4,11.97-10.6,11.08-13.82-.59-2.15-2.96-2.37-4.84-2.17-1.01.11-1.97.36-2.85.77-6.14,2.86-7.88,12.46-8.36,17.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "63.81 89.03 49.38 82.09 0 184.72 64.95 215.97 70.74 203.94 20.22 179.64 63.81 89.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "63.81 89.03 20.22 179.64 70.74 203.94 114.32 113.33 63.81 89.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.91 135.03 25.47 131.78 90.42 163.03 88.85 166.27 23.91 135.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "34.08 201.12 30.87 199.57 80.54 96.34 83.74 97.88 34.08 201.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M82.79,98.44l-1.82-1.47,1.84-1.45c.58-.46,14.24-11.08,24.41-6.19,1.25.6,2.39,1.41,3.41,2.42,3.25,3.22,3.93,6.93,1.82,9.92-3.15,4.47-12.38,6.22-22.38,1.41h0c-2.5-1.2-4.95-2.77-7.27-4.64ZM87.13,97.04c1.48,1.04,3.01,1.94,4.55,2.68h0c8.56,4.12,15.79,2.53,17.71-.2,1.28-1.82-.05-3.79-1.39-5.12-.72-.71-1.53-1.29-2.4-1.71-6.1-2.94-14.63,1.82-18.47,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.69,97.43l2.28.5-.02-2.34c0-.74-.23-18.04-10.39-22.93-1.24-.6-2.6-.99-4.02-1.15-4.54-.53-7.86,1.25-8.88,4.77-1.52,5.25,2.87,13.55,12.86,18.36h0c2.5,1.2,5.25,2.14,8.17,2.78ZM79.08,93.16c-1.74-.51-3.39-1.14-4.94-1.88h0c-8.56-4.12-11.83-10.75-10.9-13.96.62-2.14,2.99-2.33,4.87-2.11,1.01.12,1.96.39,2.84.81,6.1,2.94,7.71,12.57,8.13,17.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "89.78 147.8 84.97 145.49 98.08 118.22 102.89 120.54 89.78 147.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "128.13 141.87 119.68 141.87 119.68 182.64 227.81 182.64 227.81 175.6 128.13 175.6 128.13 141.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 128.13,
    y: 141.87,
    width: 99.68,
    height: 33.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "128.13 159.58 119.68 159.58 119.68 164.93 227.81 164.93 227.81 164 227.81 159.58 128.13 159.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "171.89 141.87 171.4 141.87 171.4 182.64 176.09 182.64 176.09 175.6 176.09 141.87 171.89 141.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.42,142.22s-14.78-2.58-19.94-9.38l4.46-4.69s9.38,10.79,15.25,11.73c0,0-5.87-2.58-7.27-8.92l2.35-1.64s3.75,9.62,7.04,10.32c0,0,4.69-5.63,2.82-12.9l4.46-1.64s3.11,9.62-6.42,16.54c0,0,9.94-3.4,12.99-7.62l1.64,3.99s-7.74,7.74-17.36,4.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 219.29,
    y: 146.47,
    width: 3.11,
    height: 9.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "382.49 278.67 375.85 283.89 401.08 315.92 486.02 249.02 481.67 243.49 403.36 305.16 382.49 278.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "382.49 278.67 403.36 305.16 481.67 243.49 460.8 216.99 382.49 278.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "393.45 292.58 386.81 297.81 390.12 302.01 475.06 235.1 474.49 234.38 471.76 230.9 393.45 292.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "416.86 251.59 416.48 251.89 441.7 283.92 445.39 281.02 441.04 275.49 420.16 248.99 416.86 251.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M417.5,251.54s-13.21,7.12-21.47,4.97l.6-6.45s14.05,2.67,19.24-.22c0,0-6.21,1.6-11.23-2.5l.83-2.74s8.9,5.23,11.92,3.76c0,0,.2-7.33-5.77-11.88l2.49-4.05s8.39,5.63,5.19,16.97c0,0,5.71-8.82,5.49-14.03l3.76,2.12s-1.29,10.87-11.03,14.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "465.45 231.64 463 233.56 456.94 225.87 459.39 223.95 465.45 231.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.01 245.16 47.58 237.44 10.33 254.02 54.3 352.81 60.73 349.94 20.2 258.87 51.01 245.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "51.01 245.16 20.2 258.87 60.73 349.94 91.54 336.23 51.01 245.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "34.83 252.36 31.4 244.64 26.51 246.81 70.48 345.6 71.32 345.23 75.36 343.43 34.83 252.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "68.8 285.13 68.61 284.69 31.36 301.26 33.27 305.55 39.7 302.69 70.51 288.97 68.8 285.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.7,285.77s-3.65-14.55.46-22.04l6.1,2.16s-6.04,12.96-4.52,18.7c0,0-.03-6.41,5.19-10.27l2.45,1.48s-7.26,7.34-6.57,10.63c0,0,7.05,2,12.94-2.67l3.31,3.41s-7.52,6.75-17.72.86c0,0,7.15,7.7,12.25,8.77l-2.98,3.12s-10.22-3.92-10.92-14.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "76.2 337.14 74.94 334.29 83.88 330.31 85.15 333.15 76.2 337.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "237.34 68.89 224.59 65.82 210.44 124.61 267.83 138.42 270.39 127.79 225.75 117.05 237.34 68.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "237.34 68.89 225.75 117.05 270.39 127.79 281.97 79.63 237.34 68.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "217.17 96.65 217.86 93.78 275.25 107.59 274.56 110.46 217.17 96.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "240.55 131.85 237.72 131.17 251.99 71.85 254.83 72.54 240.55 131.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M254.16,73.15l-1.71-.86,1.22-1.48c.38-.46,9.49-11.33,18.47-9.17,1.1.27,2.16.72,3.15,1.35,3.16,2.01,4.34,4.87,3.17,7.63-1.75,4.12-8.84,7.11-17.67,4.99h0c-2.21-.53-4.44-1.36-6.62-2.46ZM257.39,71.27c1.37.58,2.74,1.03,4.11,1.36h0c7.56,1.82,13.07-.7,14.15-3.21.71-1.68-.69-3.02-2-3.86-.7-.45-1.45-.77-2.22-.95-5.39-1.3-11.4,3.98-14.03,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M252.31,72.7h1.91s-.41-1.86-.41-1.86c-.13-.59-3.3-14.41-12.28-16.57-1.1-.27-2.25-.34-3.42-.23-3.73.36-6.08,2.36-6.29,5.35-.31,4.47,4.64,10.36,13.47,12.48h0c2.21.53,4.57.81,7.02.82ZM250.28,69.56c-1.48-.11-2.91-.33-4.28-.66h0c-7.56-1.82-11.32-6.57-11.13-9.3.13-1.82,1.99-2.38,3.53-2.53.83-.08,1.64-.03,2.41.16,5.39,1.3,8.34,8.73,9.47,12.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "271.01 101.63 267.82 100.86 272.34 82.08 275.53 82.85 271.01 101.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "319.36 69.69 311.11 71.54 320.03 111.32 425.54 87.67 424 80.8 326.73 102.6 319.36 69.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "319.36 69.69 326.73 102.6 424 80.8 416.62 47.88 319.36 69.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "323.23 86.97 314.98 88.82 316.15 94.04 421.67 70.38 421.46 69.48 420.5 65.17 323.23 86.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "362.05 60.12 361.58 60.22 370.49 100.01 375.07 98.98 373.53 92.11 366.15 59.2 362.05 60.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.65,60.34s-14.99.72-21.52-4.79l3.33-5.56s11.51,8.48,17.45,8.11c0,0-6.29-1.23-9.05-7.11l1.93-2.12s5.77,8.56,9.12,8.53c0,0,3.35-6.52-.07-13.21l3.99-2.58s5.14,8.7-2.65,17.54c0,0,8.96-5.49,11.01-10.28l2.48,3.53s-5.86,9.25-16.02,7.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "414.83 62.57 411.35 63.35 409.02 52.93 412.49 52.15 414.83 62.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "410.25 124.54 394.24 124.54 394.24 201.85 466.31 201.85 466.31 188.5 410.25 188.5 410.25 124.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 410.25,
    y: 124.54,
    width: 56.06,
    height: 63.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "424.52 124.54 419.93 124.54 419.93 201.85 440.61 201.85 440.61 188.5 440.61 124.54 424.52 124.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "468.92 157.45 468.92 152.85 391.62 152.85 391.62 173.54 404.96 173.54 468.92 173.54 468.92 157.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "456.09 106.41 437.39 113.72 437.39 125.12 456.09 132.43 456.09 106.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "404.45 106.41 404.45 132.43 423.15 125.12 423.15 113.72 404.45 106.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "437.39 112.58 423.15 112.58 423.15 113.72 423.15 125.12 423.15 126.26 437.39 126.26 437.39 125.12 437.39 113.72 437.39 112.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 460.02,
    y: 132.33,
    width: 3.11,
    height: 16.46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.45 35.52 99.87 42.16 131.95 112.5 197.53 82.59 191.99 70.45 140.99 93.71 114.45 35.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "114.45 35.52 140.99 93.71 191.99 70.45 165.45 12.26 114.45 35.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "127.43 29.6 123.25 31.5 155.33 101.84 174.15 93.26 168.61 81.11 142.07 22.92 127.43 29.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "181.48 41.11 179.58 36.93 109.24 69.01 117.82 87.83 129.97 82.29 188.16 55.75 181.48 41.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "148.63 0 134.65 14.41 139.38 24.78 159.43 23.67 148.63 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "101.64 21.43 112.44 45.1 126.42 30.69 121.69 20.32 101.64 21.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "134.17 13.37 121.22 19.28 121.69 20.32 126.42 30.69 126.9 31.73 139.85 25.82 139.38 24.78 134.65 14.41 134.17 13.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "172.62 35.64 169.79 36.93 162.96 21.95 165.79 20.66 172.62 35.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "311.44 137.74 295.76 141.03 319.14 252.5 389.67 237.7 386.93 224.64 332.07 236.14 311.44 137.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "311.44 137.74 332.07 236.14 386.93 224.64 366.3 126.24 311.44 137.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "307.82 198.53 307.08 195 377.62 180.21 378.36 183.73 307.82 198.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "356.15 244.73 352.66 245.47 329.15 133.34 332.64 132.61 356.15 244.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M332.22,133.63l-2.34-.06.57-2.27c.18-.71,4.54-17.47,15.58-19.78,1.35-.28,2.76-.34,4.18-.16,4.54.57,7.34,3.1,7.49,6.76.22,5.46-6.03,12.47-16.88,14.75h0c-2.72.57-5.61.82-8.6.75ZM334.81,129.88c1.81-.08,3.57-.29,5.24-.65h0c9.29-1.95,14.06-7.61,13.92-10.95-.09-2.22-2.35-2.97-4.22-3.21-1.01-.13-2-.09-2.95.11-6.63,1.39-10.5,10.35-12,14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.94,134.11l2.12-.99-1.44-1.84c-.45-.58-11.18-14.17-22.22-11.85-1.35.28-2.66.8-3.89,1.54-3.93,2.35-5.47,5.78-4.14,9.2,2,5.09,10.54,9,21.39,6.72h0c2.72-.57,5.47-1.5,8.17-2.77ZM326.06,131.71c-1.69.66-3.39,1.16-5.06,1.52h0c-9.3,1.95-15.93-1.32-17.15-4.43-.81-2.07.95-3.66,2.58-4.64.87-.52,1.79-.89,2.74-1.09,6.63-1.39,13.77,5.27,16.89,8.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "369.4 167.29 365.04 168.2 357.92 134.24 362.27 133.32 369.4 167.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "352.98 296.61 350.69 283.14 199.55 309.4 209.84 370.03 221.07 368.12 213.07 320.97 352.98 296.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "352.98 296.61 213.07 320.97 221.07 368.12 360.98 343.77 352.98 296.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "301.27 291.53 304.3 291.02 314.59 351.64 311.56 352.16 301.27 291.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "204.95 341.21 204.44 338.22 356.14 311.86 356.65 314.86 204.95 341.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M355.79,314.47l.13-1.99,1.91.56c.6.18,14.74,4.45,16.35,13.94.2,1.16.2,2.36,0,3.57-.64,3.85-2.88,6.15-6.01,6.16-4.67,0-10.44-5.55-12.02-14.88h0c-.4-2.34-.52-4.81-.36-7.35ZM358.91,316.8c0,1.55.13,3.05.38,4.49h0c1.36,7.99,6.03,12.24,8.87,12.23,1.9,0,2.61-1.9,2.88-3.49.14-.86.14-1.7,0-2.52-.97-5.7-8.48-9.29-12.13-10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M355.46,312.51l.78,1.84,1.62-1.16c.51-.37,12.45-9.06,10.84-18.55-.2-1.16-.59-2.29-1.18-3.37-1.87-3.42-4.75-4.85-7.71-3.83-4.41,1.53-8.02,8.69-6.44,18.02h0c.4,2.34,1.1,4.71,2.09,7.06ZM357.64,309.28c-.5-1.46-.88-2.93-1.13-4.37h0c-1.36-7.99,1.65-13.54,4.34-14.47,1.79-.62,3.09.93,3.87,2.35.42.76.7,1.56.84,2.37.97,5.7-4.94,11.57-7.92,14.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "325.88 345.06 325.24 341.31 354.43 336.36 355.07 340.1 325.88 345.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "249.42 195.91 238.47 184.22 184.59 234.71 233.87 287.3 243.61 278.17 205.28 237.27 249.42 195.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "249.42 195.91 205.28 237.27 243.61 278.17 287.74 236.82 249.42 195.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "210.21 210.7 212.84 208.23 262.12 260.83 259.49 263.29 210.21 210.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "210.45 262.3 208.01 259.7 262.38 208.77 264.81 211.36 210.45 262.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M263.72,211.54l-1.17-2.03,2.24-.69c.7-.21,17.28-5.19,24.99,3.04.95,1.01,1.72,2.18,2.31,3.49,1.87,4.17,1.16,7.87-1.89,9.91-4.55,3.03-13.79,1.32-21.37-6.77h0c-1.9-2.03-3.61-4.37-5.1-6.96ZM268.28,211.8c1.01,1.51,2.1,2.9,3.27,4.14h0c6.49,6.93,13.8,8.06,16.58,6.21,1.85-1.23,1.32-3.55.55-5.28-.42-.93-.96-1.76-1.62-2.46-4.63-4.94-14.3-3.59-18.79-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M262.13,209.84l1.95,1.29.83-2.19c.26-.69,6.3-16.91-1.41-25.14-.94-1.01-2.07-1.86-3.33-2.53-4.04-2.14-7.79-1.67-10.01,1.24-3.32,4.35-2.22,13.68,5.36,21.77h0c1.9,2.03,4.12,3.89,6.61,5.55ZM262.17,205.28c-1.44-1.1-2.76-2.29-3.93-3.54h0c-6.49-6.93-7.15-14.3-5.12-16.95,1.35-1.77,3.63-1.09,5.3-.21.9.48,1.69,1.07,2.35,1.78,4.63,4.95,2.65,14.5,1.39,18.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "263.67 252.59 260.93 249.67 279.12 232.64 281.85 235.56 263.67 252.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "-45.67 335.81 -60.19 342.56 -29.07 409.51 36.29 379.13 30.66 367.03 -20.17 390.66 -45.67 335.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "-45.67 335.81 -20.17 390.66 30.66 367.03 5.16 312.18 -45.67 335.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "-43.87 377.67 -45.39 374.4 19.96 344.02 21.48 347.29 -43.87 377.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "5.22 393.57 2 395.07 -29.41 327.52 -26.18 326.01 5.22 393.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M-26.35,327.1l-2.29.47.05-2.34c.02-.73.47-18.04,10.7-22.79,1.25-.58,2.61-.95,4.04-1.1,4.55-.47,7.84,1.36,8.82,4.89,1.45,5.27-3.05,13.52-13.11,18.19h0c-2.51,1.17-5.27,2.07-8.2,2.68ZM-24.68,322.86c1.75-.49,3.41-1.09,4.96-1.81h0c8.61-4,11.97-10.6,11.08-13.82-.59-2.15-2.96-2.37-4.84-2.17-1.01.11-1.97.36-2.85.77-6.14,2.86-7.88,12.46-8.36,17.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M-28.47,328.09l1.84-1.45-1.82-1.47c-.57-.46-14.1-11.27-24.32-6.51-1.25.58-2.41,1.38-3.44,2.38-3.29,3.17-4.02,6.87-1.95,9.9,3.09,4.51,12.3,6.38,22.36,1.71h0c2.51-1.17,4.98-2.7,7.33-4.55ZM-32.79,326.63c-1.5,1.02-3.04,1.9-4.59,2.62h0c-8.61,4-15.82,2.32-17.71-.43-1.26-1.84.1-3.79,1.46-5.1.73-.71,1.55-1.27,2.42-1.68,6.15-2.86,14.61,2.01,18.41,4.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "12.63 339.98 9 341.67 -1.5 319.07 2.12 317.39 12.63 339.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "117.27 217.01 101.26 217.01 101.26 294.32 173.33 294.32 173.33 280.97 117.27 280.97 117.27 217.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 117.27,
    y: 217.01,
    width: 56.06,
    height: 63.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "131.54 217.01 126.95 217.01 126.95 294.32 147.64 294.32 147.64 280.97 147.64 217.01 131.54 217.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.95 249.92 175.95 245.32 98.64 245.32 98.64 266.01 111.99 266.01 175.95 266.01 175.95 249.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.11 198.88 144.41 206.19 144.41 217.59 163.11 224.9 163.11 198.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "111.47 198.88 111.47 224.9 130.17 217.59 130.17 206.19 111.47 198.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "144.41 205.05 130.17 205.05 130.17 206.19 130.17 217.59 130.17 218.73 144.41 218.73 144.41 217.59 144.41 206.19 144.41 205.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 166.15,
    y: 223.02,
    width: 3.11,
    height: 17.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "440.35 19.89 425.83 26.64 456.95 93.59 522.31 63.21 516.68 51.11 465.85 74.74 440.35 19.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "440.35 19.89 465.85 74.74 516.68 51.11 491.18 -3.74 440.35 19.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "442.15 61.75 440.63 58.48 505.99 28.1 507.51 31.37 442.15 61.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "491.25 77.65 488.02 79.15 456.61 11.59 459.84 10.09 491.25 77.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M459.67,11.18l-2.29.47.05-2.34c.02-.73.47-18.04,10.7-22.79,1.25-.58,2.61-.95,4.04-1.1,4.55-.47,7.84,1.36,8.82,4.89,1.45,5.27-3.05,13.52-13.11,18.19h0c-2.51,1.17-5.27,2.07-8.2,2.68ZM461.34,6.94c1.75-.49,3.41-1.09,4.96-1.81h0c8.61-4,11.97-10.6,11.08-13.82-.59-2.15-2.96-2.37-4.84-2.17-1.01.11-1.97.36-2.85.77-6.14,2.86-7.88,12.46-8.36,17.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M457.55,12.16l1.84-1.45-1.82-1.47c-.57-.46-14.1-11.27-24.32-6.51-1.25.58-2.41,1.38-3.44,2.38-3.29,3.17-4.02,6.87-1.95,9.9,3.09,4.51,12.3,6.38,22.36,1.71h0c2.51-1.17,4.98-2.7,7.33-4.55ZM453.23,10.7c-1.5,1.02-3.04,1.9-4.59,2.62h0c-8.61,4-15.82,2.32-17.71-.43-1.26-1.84.1-3.79,1.46-5.1.73-.71,1.55-1.27,2.42-1.68,6.15-2.86,14.61,2.01,18.41,4.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "498.65 24.06 495.02 25.74 484.52 3.15 488.15 1.46 498.65 24.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.01 -70.76 47.58 -78.48 10.33 -61.91 54.3 36.88 60.73 34.02 20.2 -57.05 51.01 -70.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "51.01 -70.76 20.2 -57.05 60.73 34.02 91.54 20.31 51.01 -70.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "34.83 -63.56 31.4 -71.28 26.51 -69.11 70.48 29.68 71.32 29.31 75.36 27.51 34.83 -63.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "76.2 21.21 74.94 18.37 83.88 14.39 85.15 17.23 76.2 21.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "352.98 -19.31 350.69 -32.78 199.55 -6.52 209.84 54.11 221.07 52.2 213.07 5.05 352.98 -19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "352.98 -19.31 213.07 5.05 221.07 52.2 360.98 27.85 352.98 -19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "301.27 -24.39 304.3 -24.91 314.59 35.72 311.56 36.23 301.27 -24.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "204.95 25.29 204.44 22.3 356.14 -4.06 356.65 -1.07 204.95 25.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M355.79-1.45l.13-1.99,1.91.56c.6.18,14.74,4.45,16.35,13.94.2,1.16.2,2.36,0,3.57-.64,3.85-2.88,6.15-6.01,6.16-4.67,0-10.44-5.55-12.02-14.88h0c-.4-2.34-.52-4.81-.36-7.35ZM358.91.88c0,1.55.13,3.05.38,4.49h0c1.36,7.99,6.03,12.24,8.87,12.23,1.9,0,2.61-1.9,2.88-3.49.14-.86.14-1.7,0-2.52-.97-5.7-8.48-9.29-12.13-10.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "325.88 29.13 325.24 25.39 354.43 20.44 355.07 24.18 325.88 29.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "-45.67 19.89 -60.19 26.64 -29.07 93.59 36.29 63.21 30.66 51.11 -20.17 74.74 -45.67 19.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "-45.67 19.89 -20.17 74.74 30.66 51.11 5.16 -3.74 -45.67 19.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "-43.87 61.75 -45.39 58.48 19.96 28.1 21.48 31.37 -43.87 61.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "5.22 77.65 2 79.15 -29.41 11.59 -26.18 10.09 5.22 77.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "12.63 24.06 9 25.74 -1.5 3.15 2.12 1.46 12.63 24.06"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PATTERN"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 244.84,
    height: 250
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    width: 244.84,
    height: 250
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder1);
export default __webpack_public_path__ + "static/media/placeholder-1.0927e16d9775f4826568855b3ef49502.svg";
export { ForwardRef as ReactComponent };